import React, { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";

const ThemeToggle = ({ compact = false }) => {
  const { theme, setTheme } = useContext(ThemeContext);

  const toggleTheme = () => {
    setTheme(prev => (prev === "dark" ? "light" : "dark"));
  };

  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      style={{
        padding: compact ? "4px 8px" : "10px 16px",
        background: "var(--color-button-bg)",
        color: "var(--color-button-text)",
        border: "none",
        borderRadius: "8px",
        fontFamily: "var(--font-main)",
        fontSize: compact ? "1.2rem" : "0.9rem",
        cursor: "pointer",
        boxShadow: "var(--color-shadow)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      title={`Przełącz na tryb ${isDark ? "jasny" : "ciemny"}`}
    >
      {compact ? (isDark ? "🌙" : "☀️") : `🔄 Zmień motyw (${isDark ? "jasny" : "ciemny"})`}
    </button>
  );
};

export default ThemeToggle;
